import React from "react";
import { FaHeart } from "react-icons/fa";
import { useSelector } from "react-redux";

export const FooterApp = () => {
    const { tiny_name, privacy_notice } = useSelector((state) => state.config);

    const MiddleText = () => (
        <span>
            made with <FaHeart style={{ color: "red" }} /> by
        </span>
    );

    return (
        <footer className={"footer"}>
            <small className="center">
                © {new Date().getFullYear()} <MiddleText />
                {" - "}
                {privacy_notice ? (
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={privacy_notice}
                    >
                        {tiny_name}
                    </a>
                ) : (
                    <strong>{tiny_name}</strong>
                )}
            </small>

            {/* <br />
            <div className="social-bagdes">
                <a
                    href="https://github.com/ManzanoGlez"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img
                        alt="GitHub followers"
                        src="https://img.shields.io/github/followers/ManzanoGlez?label=github&style=social"
                    />
                </a>
            </div> */}
        </footer>
    );
};
